import { render, staticRenderFns } from "./PrehledProvedenychKorekciPCND.vue?vue&type=template&id=2f456cf0&"
import script from "./PrehledProvedenychKorekciPCND.vue?vue&type=script&lang=ts&"
export * from "./PrehledProvedenychKorekciPCND.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports